import React from 'react';

import styles from './dataPoint.module.css';
import DataPointTable from '../Form/DataPointTable';
import { LocationFormData } from '@/hooks/services/Locations';

interface DataPointProps {
  editMode: boolean;
  formData: LocationFormData;
  handleDataPointChange?: (dataPoint: string, value: boolean) => void;
  dataPointsLabels?: Record<string, string>;
}

const DataPoint: React.FC<DataPointProps> = ({
  editMode,
  formData,
  handleDataPointChange,
  dataPointsLabels
}) => {
  // Si no hay labels del endpoint, no mostrar nada
  if (!dataPointsLabels) {
    return null;
  }

  return (
    <div className={styles.content}>
      {editMode ? (
        <div className={styles.editMode}>
          <DataPointTable
            formData={formData}
            handleDataPointChange={handleDataPointChange!}
            dataPointsLabels={dataPointsLabels}
          />
        </div>
      ) : (
        <div className={styles.dataPointsLabels}>
          <span className={styles.label}>ENABLED DATA POINTS</span>
          <div className={styles.dataPointsContainer}>
            {formData?.dataPoints &&
            Object.entries(formData.dataPoints).filter(([, value]) => value)
              .length > 0 ? (
              Object.entries(formData.dataPoints)
                .filter(([, value]) => value)
                .map(([key], index, filteredArray) => (
                  <React.Fragment key={key}>
                    <span className={styles.dataPointLabel}>
                      {dataPointsLabels[key as keyof typeof dataPointsLabels]}
                    </span>
                    {index < filteredArray.length - 1 && (
                      <span className={styles.separator}>|</span>
                    )}
                  </React.Fragment>
                ))
            ) : (
              <span className={styles.dataPointLabel}>
                No data points are currently enabled
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DataPoint;
